import { Box, Stack, Typography } from '@mui/material';

/**
 * Tight bullet line used in instruction sidebars under an `InfoSection`.
 * A 4px dot + caption-sized body — keeps lists compact in the narrow
 * right column.
 */
const Bullet = ({ children }) => (
  <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ mb: 0.5 }}>
    <Box
      sx={{
        width: 4,
        height: 4,
        borderRadius: '50%',
        bgcolor: 'text.secondary',
        mt: '8px',
        flex: '0 0 4px',
      }}
    />
    <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.5 }}>
      {children}
    </Typography>
  </Stack>
);

export default Bullet;
